import React from 'react';
import AudioPreviewComponent from '../components/AudioPreview';
import RequestProvider from '../../../../RequestProvider';
import { getBynderAssetDownloadUrl as getBynderAssetDownloadUrlApi } from '../../../../../common/api';








const AudioPreviewContainer = (props) =>
<RequestProvider requests={{
  getBynderAssetDownloadUrl: getBynderAssetDownloadUrlApi()
}}>

    {(requests) => <AudioPreviewComponent {...props} {...requests} />}
  </RequestProvider>;


export default AudioPreviewContainer;